import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "GeotargetingIncentiveTextBlock" }
const _hoisted_2 = { class: "GeotargetingIncentiveText" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			'GeotargetingIncentiveWrapper',
			!_ctx.isLoading ? 'GeotargetingIncentive' : '',
			_ctx.isIncentiveDisabled ? 'GeotargetingIncentiveDisabled' : ''
		],
    isLoading: _ctx.isLoading,
    key: `${JSON.stringify(_ctx.availableEntities)}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("i", {
          class: _normalizeClass([
				'GeotargetingIncentiveIcon',
				_ctx.isIncentiveDisabled ? 'lnr-lock' : 'lnr-checkmark-circle'
			])
        }, null, 2 /* CLASS */),
        _createElementVNode("p", _hoisted_2, [
          (!_ctx.isGeotargetingMicroserviceReady)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Please wait until the geotargeting flow has finished loading. ")
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (!_ctx.isAnythingAttached)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Attach a study or organisation", -1 /* CACHED */)),
                _cache[2] || (_cache[2] = _createTextVNode(" in order to proceed with geotargeting. ", -1 /* CACHED */))
              ], 64 /* STABLE_FRAGMENT */))
            : (_ctx.hasAttachedEntityDataChanged)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _cache[5] || (_cache[5] = _createTextVNode(" You are ", -1 /* CACHED */)),
                  (_ctx.newlyAttachedStudies || _ctx.newlyAttachedOrganisations)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_3, [
                        _cache[3] || (_cache[3] = _createTextVNode(" attaching ", -1 /* CACHED */)),
                        (_ctx.newlyAttachedStudies)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.newlyAttachedStudies) + " " + _toDisplayString(_ctx.newlyAttachedStudies === 1 ? 'study' : 'studies'), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (_ctx.newlyAttachedStudies && _ctx.newlyAttachedOrganisations)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" and ")
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (_ctx.newlyAttachedOrganisations)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(_ctx.newlyAttachedOrganisations) + " " + _toDisplayString(_ctx.newlyAttachedOrganisations === 1 ? 'organisation' : 'organisations'), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (
						(_ctx.newlyAttachedStudies || _ctx.newlyAttachedOrganisations) &&
						(_ctx.newlyDetachedStudies || _ctx.newlyDetachedOrganisations)
					)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" and ")
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.newlyDetachedStudies || _ctx.newlyDetachedOrganisations)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_4, [
                        _cache[4] || (_cache[4] = _createTextVNode(" detaching ", -1 /* CACHED */)),
                        (_ctx.newlyDetachedStudies)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.newlyDetachedStudies) + " " + _toDisplayString(_ctx.newlyDetachedStudies === 1 ? 'study' : 'studies'), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (_ctx.newlyDetachedStudies && _ctx.newlyDetachedOrganisations)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" and ")
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (_ctx.newlyDetachedOrganisations)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(_ctx.newlyDetachedOrganisations) + " " + _toDisplayString(_ctx.newlyDetachedOrganisations === 1 ? 'organisation' : 'organisations'), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _cache[6] || (_cache[6] = _createTextVNode(". Press ", -1 /* CACHED */)),
                  _cache[7] || (_cache[7] = _createElementVNode("strong", { class: "SaveEmphasisText" }, " save ", -1 /* CACHED */)),
                  _cache[8] || (_cache[8] = _createTextVNode(" to proceed. ", -1 /* CACHED */))
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _cache[10] || (_cache[10] = _createTextVNode(" You have ", -1 /* CACHED */)),
                  _createElementVNode("strong", null, [
                    _cache[9] || (_cache[9] = _createTextVNode(" attached ", -1 /* CACHED */)),
                    (_ctx.attachedStudies)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.attachedStudies) + " " + _toDisplayString(_ctx.attachedStudies === 1 ? 'study' : 'studies'), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (_ctx.attachedStudies && _ctx.attachedOrganisations)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" and ")
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (_ctx.attachedOrganisations)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_ctx.attachedOrganisations) + " " + _toDisplayString(_ctx.attachedOrganisations === 1 ? 'organisation' : 'organisations'), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _cache[11] || (_cache[11] = _createTextVNode(". ", -1 /* CACHED */))
                ], 64 /* STABLE_FRAGMENT */))
        ])
      ]),
      _createElementVNode("button", {
        class: "DriverButton GeotargetingIncentiveButton",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openGeotargetingTool && _ctx.openGeotargetingTool(...args))),
        disabled: _ctx.isIncentiveDisabled
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "GeotargetingIncentiveButtonText" }, " Manage geotargeting ", -1 /* CACHED */)),
        _createElementVNode("i", {
          class: _normalizeClass([
				_ctx.isIncentiveDisabled ? 'lnr-earth-lock' : 'lnr-earth',
				'GeotargetingIncentiveButtonIcon'
			])
        }, null, 2 /* CLASS */)
      ], 8 /* PROPS */, _hoisted_5)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["classes", "isLoading"]))
}